import * as React from "react";
const SvgFiRrHourglassEnd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 24H7.005a4.01 4.01 0 0 1-3.848-2.879 3.9 3.9 0 0 1-.113-1.679A12.52 12.52 0 0 1 7.445 12a12.52 12.52 0 0 1-4.4-7.444A3.94 3.94 0 0 1 3.961 1.4 4.01 4.01 0 0 1 7.005 0H17a4.02 4.02 0 0 1 3.847 2.877c.159.545.198 1.117.115 1.678A12.56 12.56 0 0 1 16.551 12a12.56 12.56 0 0 1 4.406 7.448 3.95 3.95 0 0 1-.918 3.156A4.02 4.02 0 0 1 17 24m0-22H7.005a2.015 2.015 0 0 0-1.928 1.428 1.9 1.9 0 0 0-.056.828c.376 2.5 1.924 4.84 4.6 6.957a1 1 0 0 1 0 1.568c-2.676 2.119-4.221 4.461-4.6 6.96a1.92 1.92 0 0 0 .456 1.559 2.02 2.02 0 0 0 1.528.7H17a2.015 2.015 0 0 0 1.928-1.427c.079-.268.098-.55.056-.827-.373-2.487-1.92-4.829-4.6-6.962a1 1 0 0 1 0-1.564c2.681-2.133 4.228-4.475 4.6-6.963a1.92 1.92 0 0 0-.461-1.557A2.01 2.01 0 0 0 17 2m-1.319 18H8.318a1 1 0 0 1-.927-1.374 11.2 11.2 0 0 1 3.471-4.272l.518-.412a1 1 0 0 1 1.245 0l.509.406a11.3 11.3 0 0 1 3.473 4.276A1 1 0 0 1 15.681 20m-5.647-2h3.928A11.6 11.6 0 0 0 12 16a11.3 11.3 0 0 0-1.966 2"
    />
  </svg>
);
export default SvgFiRrHourglassEnd;
